import { Badge } from "@/deps/ui-library";
import type { QuotationStatus } from "@/api/types";

const STATUS: Record<
  QuotationStatus,
  { label: string; scheme: "default" | "info" | "success" | "danger" | "warning" | "primary" }
> = {
  draft: { label: "Draft", scheme: "default" },
  sent: { label: "Sent", scheme: "info" },
  accepted: { label: "Accepted", scheme: "success" },
  declined: { label: "Declined", scheme: "danger" },
  expired: { label: "Expired", scheme: "warning" },
  converted: { label: "Converted", scheme: "primary" },
};

export function QuotationStatusBadge({ status }: { status: QuotationStatus }) {
  const { label, scheme } = STATUS[status];
  return (
    <Badge variant="soft" size="sm" colorScheme={scheme}>
      {label}
    </Badge>
  );
}
